import React, { useEffect, useState } from 'react'
import Navbar from '../components/Navbar'
import { Box, display } from '@mui/system'
import { Drawer, Grid, IconButton, TextField, Typography } from '@mui/material'
import EmployerSidebar from '../components/Employer/EmployerSidebar'
import { useDispatch, useSelector } from 'react-redux'
import { getUserInformation } from '../actions/userAuth'
import JobForm from '../components/Employer/JobForm'
import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate, useParams } from 'react-router-dom';
import EditJobForm from '../components/Employer/EditJobForm'

const EditJob = () => {
    const { user } = useSelector((state) => ({ ...state }));
    const { id } = useParams();
    const navigate = useNavigate();
    useEffect(() => {
        if (!localStorage.getItem("user")) {
            navigate('/')
        }
    }, [])

    const handleSearch = (event) => {
        const searchTerm = event.target.value;
    };
    return (
        <>
            <Box
                sx={{
                    background: 'linear-gradient(270deg, #F2F4FB 0%, #EFF2FA 25.93%, #E8EDF9 67.2%, #C8D8F1 100%)'
                }}>
                <Navbar />
            </Box>
            <Grid container mt={10} >
                <Grid item md={2}>
                    <Box sx={{}}>
                        <EmployerSidebar user={user} />
                    </Box>
                </Grid>

                <Grid item md={10} px={{md:5, xs:1}} >
                    {/* <Box sx={{ display: 'flex', flexDirection: 'row', my: 4, borderRadius: '10px' }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', width: '100%' }}>Post a Job</Typography>
                        <TextField
                            sx={{ background: '#3665D014', width: '70%', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)', }} // Updated style
                            variant="outlined"
                            size="small"
                            placeholder="Search"
                            onChange={handleSearch}
                            InputProps={{
                                endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                            }}
                        />
                    </Box> */}
                    <Box sx={{ my: 8 }}>
                        <EditJobForm id={id} />
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}

export default EditJob;